// eslint-disable-next-line @typescript-eslint/no-unused-vars
import {helpers} from 'commerce-sdk-isomorphic';

import AbstractCustomShopperAPI from '../AbstractCustomShopperAPI';
import {ICustomApiConfig} from '../ICustomApiConfig';

/**
 * Represents CustomShopper__NAME__
 */
class CustomShopper__NAME__ extends AbstractCustomShopperAPI {
	/**
	 * @constructor
	 * @param {ICustomApiConfig} config - API Config
	 */
	constructor(config: ICustomApiConfig) {
		super(config);
	}
}

export default CustomShopper__NAME__;
